<template>
    <v-dialog-old ref="dialog" id="lineEdit" :overflow="true">
        <ValidationObserver ref="lineEdit">
        <form>
            <fieldset style="min-width: 400px">
                <legend>Услуга</legend>
                <div>
                    <div v-for="(cat, index) in line.category">
                        <label v-if="index===0">Категория</label>
                        <label v-else>Подкатегория {{ index }}</label>

                        <div class="category-select-wrapper">
                            <v-select v-model="line.category[index]"
                                      :ref="'select' + index"
                                      style="width: calc(100% - 16px)"
                                      :options='[
                                      ...filteredCategories.map(row => {
                                          return {
                                              value: row,
                                              text: row
                                          };
                                      })
                                  ]'
                                      :preserve-search="true"
                                      @close="addNewCategory(index)"
                            ></v-select>

                            <i @click="delCategory(index)" class="clearBut">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="1em" height="1em"><path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"></path></svg>
                            </i>
                        </div>
                    </div>

                    <button v-if="line.category.length < 3"
                        @click.prevent="addCategory" class="tiny"> Добавить категорию
                    </button>

                    <label>Наименование услуги</label>
                    <vee-input v-model="line.name"
                               rules="required"
                               @blur="onNameInput(); matchTags()"/>

                    <label>Описание</label>
                    <textarea v-model="line.description" @change="onDescriptionInput"/>

                    <div style="width: 150px">
                        <label>Код</label>
                        <v-input v-model="line.code" />
                    </div>
                </div>
                <div>
                    <span class="inlineBLock tag__span__radio"><input class="tag__span__radio__input" type="radio" name="priceType" v-model="priceIsRange" :value="false"></span>
                    <span class="inlineBLock">
                        <label>Цена</label>
                        <vee-input name="Цена"
                                   class="inlineBLock input__price"
                                   :rules="{max: 7, required: line.price_discount !== null && line.price_discount !== '', min_value: 0}"
                                   type="number"
                                   :disabled="priceIsRange"
                                   v-model="line.price"/> руб.
                    </span>
                    <span class="inlineBLock">
                        <label>Цена со скидкой</label>
                        <vee-input name="Цена со скидкой"
                                   class="inlineBLock input__price"
                                   :rules="{max: 7, max_value: line.price ? line.price - 1 : false, min_value: 0}"
                                   type="number"
                                   :disabled="priceIsRange"
                                   v-model="line.price_discount"/> руб.
                    </span>
                    <span class="inlineBLock tag__span__radio" style="margin-left: 35px;">
                        <input class="tag__span__radio__input" type="radio" name="priceType" v-model="priceIsRange" :value="true">
                    </span>
                    <span class="inlineBLock">
                        <label>Цена от</label>
                        <vee-input name="Цена от"
                                   class="inlineBLock input__price"
                                   :rules="{max: 7, max_value: line.price_to ? line.price_to - 1 : false, min_value: 0}"
                                   type="number"
                                   :disabled="!priceIsRange"
                                   v-model="line.price_from"/> руб.
                    </span>
                    <span class="inlineBLock">
                        <label>Цена до</label>
                        <vee-input name="Цена до"
                                   class="inlineBLock input__price"
                                   :rules="{min_value: line.price_from !== null && line.price_from !== '' ? Number(line.price_from) + 1 : 0, max: 7}"
                                   type="number"
                                   :disabled="!priceIsRange"
                                   v-model="line.price_to"/> руб.
                    </span>

                </div>
            </fieldset>
            <fieldset style="overflow-x: initial !important; overflow-y: scroll; max-height: calc(45vh - 100px);">
                <legend>Теги</legend>
                <table class="table table__tags" style="table-layout: fixed;" v-if="line.services.length > 0">
                    <thead>
                        <tr>
                            <th>Наименование</th>
                            <th width="55">Создал</th>
                            <th width="155">Тип совпадения</th>
                            <th width="50">Релев.</th>
                            <th width="145">Статус</th>
                            <th width="85">Действ. <i class="fad fa-person-simple"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(service) in line.services">
                            <td style="text-align:initial !important; padding-left: 8px !important;">
                                {{ service.name }}
                            </td>
                            <td>
                                <template v-if="service.author.fioInitials==='Асад'">
                                    <i class="fal fa-robot" v-tooltip="service.author.fio"></i>
                                </template>
                                <template v-else>
                                    <span v-tooltip="service.author.fio">{{ service.author.fioInitials }}</span>
                                </template>
                            </td>
                            <td>
                                {{ tagMatchTypes[service.type] }}
                            </td>
                            <td>
                                <span v-if="service.predict === null">
                                  --
                                </span>
                                <span v-else :class="[service.predict < minPredict ? 'tag__decline' : 'tag__accept']">
                                    {{ Math.round(service.predict) }}
                                </span>
                            </td>
                            <td v-html="tagStatuses[getPreparedStatus(service)]">

                            </td>
                            <td>
                                <button @click.prevent="service.status='ACCEPTED_MANUAL'" style="width:21px" :class="[service.status==='ACCEPTED_MANUAL' ?  'fad green' : 'fa-icon pointer']" class="fa-check tiny greenHover "/>
                                <button @click.prevent="service.status='DECLINED_MANUAL'" style="width:21px" :class="[service.status==='DECLINED_MANUAL' ?  'fad red' : 'fa-icon pointer']" class="fa-xmark tiny redHover"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
            <div style="margin-top:17px;padding-left: 8px;">
                <span style="display:inline-block">Добавить тег: </span>
                <v-select style="width: 481px;display:inline-block"
                          :options="foundTags"
                          @search-change="searchTags"
                          v-model="searchingTag"
                              @select="addTag"
                          :placeholder="getSearchTagVal()"
                              ref="searchTags"
                ></v-select>
                <button type="button" class="tiny" @click.prevent="$refs.tagsTreeDialog.$refs.addTagsFromListDialog.show()">
                    Выбрать из списка
                </button>
                <AddTagsFromList
                    ref="tagsTreeDialog"
                    :services="line.services"
                    v-bind="$props"
                    @servicesChanged="updateServices"
                />
            </div>
        </form>
        </ValidationObserver>

        <template v-slot:footer>
            <v-loading-component @click="saveLine">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{green: true}, loadingClass]">Подтвердить</button>
                </template>
            </v-loading-component>
            <v-loading-component @click="deleteLine">
                <template slot-scope="{ loadingClass }">
                    <button :class="[{red: true}, loadingClass]">Удалить услугу</button>
                </template>
            </v-loading-component>
        </template>
    </v-dialog-old>
</template>

<script>
import { mapState } from "vuex";
import AddTagsFromList from "../AddTagsFromList"
import _ from "lodash";

export default {
    components: { AddTagsFromList },
    props: ['minPredict','fileId', 'servicesTree', 'categories'],
    data: function () {
        return {
            priceIsRange: false,
            foundTags: [],
            tagStatuses: {
                'ACCEPTED': '<span class="tag__accept">Подтвержден</span>',
                'ACCEPTED_MANUAL': '<span class="tag__accept">Подтвержден <i class="fad fa-person-simple"></i></span>',
                'DECLINED': '<span class="tag__decline">Отклонен</span>',
                'DECLINED_MANUAL': '<span class="tag__decline">Отклонен <i class="fad fa-person-simple"></i></span>',
            },
            tagMatchTypes: {
                predict: 'По релевантности',
                code: 'По коду(НМУ)',
                manual: 'Вручную',
                direct: 'Точное совпадение',
            },
            line: {
                id: null,
                code: null,
                category: [],
                name: '',
                price: null,
                price_from: null,
                price_to: null,
                price_discount: null,
                services: [],
                description: null,
            },
            categoriesList: JSON.parse(JSON.stringify(this.categories)),
            searchingTag: null,
        }
    },
    methods: {
        deleteLine(btn){
            btn.startLoadingAnimation();
            this.axios.post('doctu/lines/' + this.line.id + '/delete' )
                .then(() => {
                    btn.stopLoadingAnimation();
                    this.$refs.dialog.hide();
                    this.$parent.$parent.$refs.table.update();
                }, () => {btn.stopLoadingAnimation() });
        },
        getPreparedStatus(tag) {
            if (tag.status === 'NEW') {
                return tag.type === 'predict' && tag.predict < this.minPredict ? 'DECLINED' : 'ACCEPTED'
            }
            return tag.status;
        },
        matchTags() {
            if (this.line.name) {
                this.axios.post('doctu/lines/matchTags', {
                    categories: this.line.category,
                    name: this.line.name
                }).then(response => {
                    Object.values(response.data).forEach(newTag => {
                        let hasThisTag = false;
                        this.line.services.forEach(service => {
                            if (service.id === newTag.serviceId) {
                                hasThisTag = true;
                            }
                        });

                        if (!hasThisTag) {
                            this.line.services.push({
                                id: newTag.serviceId,
                                name: newTag.serviceName,
                                author: {fio: this.currentUser.fio,fioInitials: this.currentUser.fioInitials},
                                predict: newTag.predict,
                                isNewTag: true,
                                status: 'ACCEPTED_MANUAL',
                                type: 'manual'
                            });
                        }
                    });
                })
            }
        },
        searchTags(query) {
            if (query.length > 2){
                this.axios.post('/getServices', {
                    q:query,
                    except: this.excludeTagIds
                }).then(response => {
                    this.foundTags = response.data.map(item => {
                        return {
                            id: item.id,
                            text: item.name,
                        }
                    })
                })
            }else{
                this.foundTags = [];
            }
        },
        delCategory(index) {
            this.line.category.splice(index, 1);
        },
        delTag(index) {
            this.line.services.splice(index, 1);
        },
        addCategory() {
            this.line.category.push('');
        },
        addTag: function (payload) {
            this.line.services.push({
                id: payload.id,
                name: payload.text,
                author: {fio: this.currentUser.fio,fioInitials: this.currentUser.fioInitials},
                predict: null,
                isNewTag: true,
                status: "ACCEPTED_MANUAL",
                type: 'manual'
            });
            this.$nextTick(() => {
                this.foundTags = [];
                this.searchingTag = null;
            });
        },
        saveLine(btn){
            btn.startLoadingAnimation();
            this.$refs.lineEdit.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    el.scrollIntoView({behavior: "smooth"});
                    btn.stopLoadingAnimation()
                    return;
                }
                if (this.line.id === null) {
                    var url = 'doctu/' + this.fileId + '/addLine';
                } else {
                    var url = 'doctu/lines/' + this.line.id + '/update';
                }
                this.axios.post(url, this.line).then((response) => {
                    btn.stopLoadingAnimation();
                    this.$refs.dialog.hide();
                    this.$parent.$parent.$refs.table.update();
                    this.$parent.$parent.getCategories();
                }, () => {
                    btn.stopLoadingAnimation()
                });
            });
        },
        resetData(){
            this.line.id = null;
            this.line.code = null;
            this.line.category = [];
            this.line.name = '';
            this.line.price = null;
            this.line.price_from = null;
            this.line.price_to = null;
            this.line.price_discount = null;
            this.line.services = [];
            this.line.description = null;
            this.categoriesList = JSON.parse(JSON.stringify(this.categories));
        },
        show(id) {
            this.resetData()
            if (id !== undefined) {
                return this.axios.get('doctu/lines/' + id).then(response => {
                    Object.assign(this.line, response.data)
                    this.priceIsRange = this.line.price === null && (this.line.price_from !== null || this.price_to !== null)
                    this.$refs.dialog.show()
                })
            } else {
                this.$refs.dialog.show()
            }
        },
        updateServices(newVal) {
            newVal.forEach(item => {
                let hasTag = false;
                this.line.services.forEach(service => {
                    if (service.id === item.id) {
                        hasTag = true;
                    }
                })
                if (!hasTag) {
                    this.addTag(item);
                }
            });
        },
        getSearchTagVal() {
            const searchVal = this.$refs.searchTags && this.$refs.searchTags.$refs.multiselect
                ? this.$refs.searchTags.$refs.multiselect.search
                : '';

            return searchVal ? searchVal : 'искать';
        },
        addNewCategory(index) {
            let newVal = this.$refs['select' + index][0].$refs.multiselect.search;

            if (!newVal) {
                return;
            }

            newVal = _.upperFirst(newVal);

            if (this.categoriesList.indexOf(newVal) === -1) {
                this.categoriesList.push(newVal);
            }

            this.line.category[index] = newVal;

            this.$refs['select' + index][0].$refs.multiselect.search = '';
        },
        onNameInput() {
            this.line.name = _.upperFirst(this.line.name);
        },
        onDescriptionInput() {
            this.line.description = _.upperFirst(this.line.description);
        },
    },

    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
        }),
        excludeTagIds () {
            return this.line.services.map((service) => service.id)
        },
        filteredCategories () {
            let preparedList = this.categoriesList;

            if (preparedList.indexOf('') === -1) {
                preparedList.unshift('');
            }

            preparedList = [...new Set(preparedList)];

            return preparedList;
        }
    },

    watch: {
        priceIsRange(n) {
            if (n === true) {
                this.line.price = null;
                this.line.price_discount = null;
            } else {
                this.line.price_to = null;
                this.line.price_from = null;
            }
        },
        categories(newList) {
            this.categoriesList = JSON.parse(JSON.stringify(newList));
        }
    }
}
</script>

<style>


.inlineBLock {
    display: inline-block;
}

.input__price {
    width: 90px !important;
}

#lineEdit {
    width: 1200px;
    overflow: visible;
}

.tag__accept {
    color: mediumseagreen !important;
}

.pointer {
    cursor: pointer;
}

.tag__decline {
    color: red !important;
}

.tagStatus {
    width: 125px;
    float: right;
    text-align: center;
    padding-top: 21px;
    padding-right: 10px;
}

.table__tags {
    text-align: center
}

.table__tags th {
    font-size: 12px;
    text-align: center;
}
.tag__span__radio {
    width:18px;
}
.tag__span__radio__input {
    margin-left: 1px !important;
}
#lineEditBody fieldset {
    overflow: visible;
}
#lineEditBody .category-select-wrapper {
    position: relative;
}
#lineEditBody .category-select-wrapper .clearBut {
    right: -2px;
}
</style>
